export function roundPercent(value) {
    return Math.round(value * 100) / 100;
}

export function removeVi(str) {
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    str = str.replace(/đ/g, "d");
    str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
    str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
    str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
    str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
    str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
    str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
    str = str.replace(/Đ/g, "D");
    return str;
}

export function trim(str) {
    if (str) {
        for (let key in str) {
            if (str.hasOwnProperty(key)) {
                str[key] = (str[key] && isString(str[key])) ? str[key].trim() : str[key];
            }
        }
    }
    return str;
}

export function isString(obj) {
    return (Object.prototype.toString.call(obj) === '[object String]');
}

export function isNullOrEmpty(input) {
    return input === undefined || input === null || input === "";
}

export const stringNullOrEmpty = (string) => {
    return string === undefined || string === null || string === "" || string === "Invalid date";
};

export const genSso = (redirectUrl, renew = false, appId = 2) => {
    let url = new URL( window.location.origin + "/sso/login");
    url.searchParams.append('appId', appId);
    url.searchParams.append('redirectUrl', redirectUrl);
    url.searchParams.append('renew', renew);
    return url.href;
}
